import React from 'react';
import { Spin } from 'antd';

const LoadingSpinner = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      width: '100vw',
      background: '#f0f2f5'
    }}>
      <Spin size="large" tip="Loading..." />
    </div>
  );
};

export default LoadingSpinner; 